// extracted by mini-css-extract-plugin
export default {"advertCardPhoto":"c-a_ht","advertCardPhoto__image":"c-a_hu"};